  import i18n from '@/lang' // Internationalization

 /* eslint-disable */
 function emailIsValid (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

const string = ({ label, required, min, max }) => {
  const output = [];

  if (required) {
    output.push({ required: !!required, message: label + ' ' + i18n.t('validators.isRequired') });
  }

  if (min || min === 0) {
    output.push({ min, message: `${label} ${i18n.t('validators.lenghtMustBeLeast')} ${min}` });
  }

  if (max || max === 0) {
    output.push({ max, message: `${label} ${i18n.t('validators.lenghtMustBeMax')} ${max}` });
  }

  return output;
};


const email = ({ label, required, min, max }) => {
  const emailFn = (rule, value, callback) => {
    if (!value) {
      callback();
      return;
    }

    if (emailIsValid(value)) {
      callback();
      return;
    }

    callback(new Error(i18n.t('validators.lenghtMustBeMax')));
  };

  const requiredFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback(new Error(i18n.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  const output = [];

  if (required) {
    output.push({ required: true, validator: requiredFn, message: `${label} ${i18n.t('validators.isRequired')}` });
  }

  output.push({ validator: emailFn, message: `${label}  ${i18n.t('validators.mustBeEmail')} ` });
  
  return output
};

const decimal = ({ label, required, min, max }) => {
  const output = [
    { type: 'number', message: `${label} ${i18n.t('validators.mustBeEmail')}` },
  ];

  if (required) {
    output.push({ type: 'number', required: !!required, message: `${label} ${i18n.t('validators.isRequired')}` });
  }

  if (min || min === 0) {
    output.push({ type: 'number', min, message: `${label} ${i18n.t('validators.mustBeAtLeast')} ${min}` });
  }

  if (max || max === 0) {
    output.push({ type: 'number', max, message: `${label} ${i18n.t('validators.mustBeAMaxOf')} ${max}` });
  }

  return output;
};

const integer = ({ label, required, min, max }) => {
  const integerFn = (rule, value, callback) => {
    if (!value) {
      callback();
      return;
    }

    if (Number.isInteger(value)) {
      callback();
      return;
    }

    callback(new Error(i18n.t('validators.valueShouldInteger')));
  };

  return [
    { validator: integerFn, message: `${label} ${i18n.t('validators.valueShouldInteger')}` },
    ...decimal({ label, required, min, max }),
  ];
};



const generic = ({ label, required }) => {
  const output = [];

  if (required) {
    output.push({ required: true, message: `${label} ${i18n.t('validators.isRequired')}` });
  }

  return output;
};

const hasOne = ({ label, required }) => {
  const requiredFn = (rule, value, callback) => {
    if (!value) {
      callback(new Error(i18n.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  if (!required) {
    return [];
  }

  return [
    { required: true, validator: requiredFn, message: `${label} ${i18n.t('validators.valueIsRequired')}` },
  ];
};

const hasMany = ({ label, required, min, max }) => {
  const requiredFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback(new Error(i18n.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  const minFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback();
      return;
    }

    if (value.length < min) {
      callback(new Error(`${i18n.t('validators.valueSize')} ${i18n.t('validators.mustBeAtLeast')} ${min}`));
    }

    callback();
  };

  const maxFn = (rule, value, callback) => {
    if (!value || !value.length) {
      callback();
      return;
    }

    if (value.length > max) {
      callback(new Error(`${i18n.t('validators.valueSize')} ${i18n.t('validators.mustBeAMaxOf')} ${max}`));
    }

    callback();
  };

  const output = [];

  if (required) {
    output.push({ required: true, validator: requiredFn, message: `${label} ${i18n.t('validators.isRequired')}` });
  }

  if (min || min === 0) {
    output.push({ validator: minFn, message: `${label} ${i18n.t('validators.size')} ${i18n.t('validators.mustBeAtLeast')}  ${min}` });
  }

  if (max || max === 0) {
    output.push({ validator: maxFn, message: `${label} ${i18n.t('validators.size')} ${i18n.t('validators.mustBeAMaxOf')}${max}` });
  }

  return output;
};


export default {
  string,
  email,
  integer,
  decimal,
  generic,
  hasOne,
  hasMany,
};



// WEBPACK FOOTER //
// ./src/shared/form/validators.js